import React from 'react'

function AvisoLegal() {
    return (
        <div className='degradado'>
            <div className="nosotros dos">
                <h2 id='dron' className='subtitulo tres'>
                    AVISO LEGAL
                </h2>
            </div>
            <div className="flexzone">


                <p className='cookies'>

                    1. Datos identificativos:
                    En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:
                    Titular de la web: Verónica Martínez Castillo.
                    Domicilio social: C/Imperial 33, 02006, Albacete, Castilla La Mancaha, España.
                    Correo electrónico de contacto: info@drontalia.es
                    Teléfono de contacto: +34 606024660
                     <br /><br />
                    2. Usuarios:
                    El acceso y/o uso de este sitio web atribuye la condición de Usuario, que acepta, desde dicho acceso y/o uso, las presentes condiciones de uso. <br />
                    3. Uso del portal:
                    El sitio web proporciona el acceso a información, servicios, programas o datos en Internet
                    pertenecientes a Verónica Martínez Castillo o a sus licenciantes. El usuario asume la responsabilidad del uso de la web. <br /><br />
                    4. Protección de datos:
                    El titular cumple con las directrices del Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD),
                    garantizando el correcto uso y tratamiento de los datos personales del usuario. Para más información consulte
                    nuestra Política de Privacidad. <br /><br />
                    5. Propiedad intelectual e industrial:
                    Todos los contenidos de la web (textos, imágenes, diseños, logotipos, etc.) son propiedad de Verónica Martínez Castillo,
                    o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución o transformación sin autorización expresa. <br /><br />
                    6. Exclusión de garantías y responsabilidad:
                    El titular no se hace responsable, en ningún caso, de los daños y perjuicios que pudieran ocasionar,
                    por ejemplo: errores u omisiones en los contenidos, falta de disponibilidad del portal, transmisión de virus o programas maliciosos. <br /><br />
                    7. Modificaciones:
                    El titular se reserva el derecho de realizar cambios en la web sin previo aviso,
                    pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios como la forma en la que éstos aparezcan presentados. <br /><br />
                    8. Enlaces:
                    En caso de que se dispongan enlaces a otros sitios web, el titular no ejercerá ningún tipo de control
                    sobre dichos sitios y contenidos, no asumiendo responsabilidad alguna. <br /><br />
                    9. Derecho de exclusión:
                    El titular se reserva el derecho a denegar o retirar el acceso al portal a aquellos usuarios que incumplan las presentes condiciones. <br /><br />
                    10. Legislación aplicable y jurisdicción:
                    La relación entre Drontalia y el usuario se regirá por la normativa española vigente, y cualquier controversia se someterá a los Juzgados y Tribunales de Albacete.

                </p>
            </div>
        </div>
    )
}

export default AvisoLegal

